// Bootstrap
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import ListGroup from 'react-bootstrap/ListGroup';
// Libs
import { TwitterShareButton } from 'react-twitter-embed';

const Home = () => {
  return (
    <>
      <Row className="justify-content-md-center text-center" style={{marginTop: "48px"}}>
        <Col md="5">
          <span style={{fontSize: "3rem"}}>🤼</span>
          <h1 style={{fontSize: "2rem"}}>community</h1>
          <br/>
          <ListGroup>
            <ListGroup.Item variant={"light"}>
              <strong>ventures</strong>: 5
            </ListGroup.Item>
            <ListGroup.Item variant={"light"}>
              <strong>members</strong>: 7
            </ListGroup.Item>
            <ListGroup.Item variant={"light"}>
              <strong>rituals</strong>: 2
            </ListGroup.Item>
          </ListGroup>
        </Col>
      </Row>
      <Row className="justify-content-md-center text-center" style={{marginTop: "48px"}}>
        <Col md="5">
        <h2>✊🏼 manifest</h2>
        <br/>
        <ListGroup>
            <ListGroup.Item variant={"light"}>
              free membership
            </ListGroup.Item>
            <ListGroup.Item variant={"light"}>
              we decide who we let in
            </ListGroup.Item>
            <ListGroup.Item variant={"light"}>
              we decide if you need to leave
            </ListGroup.Item>
        </ListGroup>
        <br/><br/>
        <h2>🎭 roles</h2>
        <br/>
        <ListGroup>
            <ListGroup.Item variant={"light"}>
             builders build a venture
            </ListGroup.Item>
            <ListGroup.Item variant={"light"}>
              mentors help the builders
            </ListGroup.Item>
            <ListGroup.Item variant={"light"}>
             talents contribute to ventures 
            </ListGroup.Item>
        </ListGroup>
      
        <br/><br/>
        <h2>📖 rules</h2>
        <br/>
        <ListGroup>
            <ListGroup.Item variant={"light"}>
              open your cards
            </ListGroup.Item>
            <ListGroup.Item variant={"light"}>
              no sugar-coating
            </ListGroup.Item>
            <ListGroup.Item variant={"light"}>
              keep up with commitments
            </ListGroup.Item>
        </ListGroup>

        <br/><br/>
        <h2>🤝 commitments</h2>
        <br/>
        <ListGroup>
            <ListGroup.Item variant={"light"}>
              be active, don't shit post
            </ListGroup.Item>
            <ListGroup.Item variant={"light"}>
              join monthly 🪵 #firepit event
            </ListGroup.Item>
            <ListGroup.Item variant={"light"}>
              open calendar for one-on-one calls
            </ListGroup.Item>
        </ListGroup>
        </Col>
      </Row>
      <Row className="justify-content-md-center text-center" style={{marginTop: "48px"}}>
        <Col md="5">
          <span style={{fontSize: "3rem"}}>🏋️‍♂️</span>
          <br/>
          <h1 style={{fontSize: "2rem"}}>want to be part of it?</h1>
          <Link to="/join">join the community</Link>
        </Col>
      </Row>

      <Row className="justify-content-md-center text-center" style={{marginTop: "48px"}}></Row>
    </>
  );
};

export default Home;
